import { Tabs } from 'antd'
import { useEffect } from 'react'
import Schedule from './Schedule'
import AppLayout from '../../../components/layout/layout'
import SessionActivity from '../../Sessions/Profiles/SessionActivities'
import EventAnalytics from './Analytics'
import ProfileHeader from './ProfileHeader'
import EventDetails from './Details'
import { useParams } from 'react-router-dom'
import { getEventById } from '../../../api/Events'
import { useQuery } from '@tanstack/react-query'
import Loader from 'helper/Loader'
import EventManagers from './EventManagers/EventManagers'
import Reviews from './Reviews'
import Attendace from './Attendances'
import { eventDetailsStore } from 'state/event/eventDetails'
import { useGetSearchParams } from 'hooks/useGetSearchParams'
const { TabPane } = Tabs
const EventsDetails = () => {
  const { id }: any = useParams()
  const params = useGetSearchParams(['tab'])

  const setEventDetailedData = eventDetailsStore(
    store => store.setEventDetailedData,
  )
  const eventId = id
  const {
    data: event,
    isLoading,
    refetch,
  } = useQuery(
    ['getEventById', id],
    () => {
      return getEventById(id)
    },
    { enabled: false },
  )

  useEffect(() => {
    if (eventId) {
      refetch()
    }
  }, [eventId, refetch])

  useEffect(() => {
    if (event) {
      setEventDetailedData(event)
    }
  }, [event])

  if (isLoading) {
    return <Loader />
  }

  return (
    <AppLayout>
      <div className="container bg-grey">
        <div className="org-profile-header pt-30">
          <ProfileHeader event={event} />
        </div>
        <Tabs
          defaultActiveKey={params.tab || '1'}
          className="bg-white profile-tabs"
        >
          <TabPane tab="Details" key="1">
            <EventDetails event={event} />
          </TabPane>
          <TabPane tab="Schedule" key="2">
            <Schedule event={event} />
          </TabPane>
          <TabPane tab="Updates" key="3" className={'event-tab-items'}>
            <SessionActivity contractRoomId={id} />
          </TabPane>
          <TabPane tab="Analytics" key="4">
            <EventAnalytics event={event} />
          </TabPane>
          <TabPane tab="Attendace" key="attendance">
            <Attendace />
          </TabPane>
          {/* <TabPane tab="Payment" key="6">
            <Payments />
          </TabPane> */}
          <TabPane tab="Event Managers" key="7">
            <EventManagers eventManagers={event.organizers} />
          </TabPane>
          <TabPane tab="Reviews" key="8">
            <Reviews />
          </TabPane>
          <TabPane tab="Staff" key="9"></TabPane>
          <TabPane tab="Notes" key="10"></TabPane>{' '}
        </Tabs>
      </div>
    </AppLayout>
  )
}

export default EventsDetails
